import { State, RegisterDevice, ValidationPL, DeviceValidated } from './model';
import * as Devices from '../../devices';
import { CallStatusDefault } from '../../../models';

export const RegisterDeviceDefault = (pk: Devices.PKey, code = '') =>
  ({
    ...CallStatusDefault,
    ...Devices.DevicePkDefault(pk),
    code,
    // isValid: false
  } as RegisterDevice);

export const StateDefault: State = {
  ...CallStatusDefault,
  keys: [],
  editingDevice: undefined,
};

export const DeviceValidatedDefault = (key: Devices.PKey) =>
  ({
    ...key,
    message: '',
  } as DeviceValidated);

export const ValidationPayloadDefault = (key: Devices.PKey, code: string) =>
  ({
    validatedDevice: DeviceValidatedDefault(key),
    code,
  } as ValidationPL);
